import { PaletteMode } from "@mui/material/styles";
import ThemeModeContext from "components/ThemeModeProvider/ThemeModeContext";
import React from "react";

type Props = {
  children: React.ReactNode;
};

const ThemeModeProvider: React.FC<Props> = ({ children }) => {
  const [themeMode, setThemeMode] = React.useState<PaletteMode>("light");

  const toggleThemeMode = React.useCallback(() => {
    setThemeMode((prevState) => {
      if (prevState === "dark") {
        localStorage.setItem(THEME_MODE_STORAGE_KEY, "light");
        return "light";
      }

      localStorage.setItem(THEME_MODE_STORAGE_KEY, "dark");
      return "dark";
    });
  }, []);

  React.useEffect(() => {
    const themeModeFromLocalStorage = getThemeModeFromLocalStorage();
    setThemeMode(themeModeFromLocalStorage);
  }, []);

  const contextValue = React.useMemo(() => {
    return { themeMode, toggleThemeMode };
  }, [themeMode, toggleThemeMode]);

  return <ThemeModeContext.Provider value={contextValue}>{children}</ThemeModeContext.Provider>;
};

const THEME_MODE_STORAGE_KEY = "objective.build.registers.theme.mode";

const getThemeModeFromLocalStorage = () => {
  const value = localStorage.getItem(THEME_MODE_STORAGE_KEY);
  if (value === "dark") {
    return "dark";
  }
  return "light";
};

export default ThemeModeProvider;
